import React from 'react';

const avatarColors = [
  'bg-purple-soft text-purple',
  'bg-red-soft text-red',
  'bg-green-soft text-green',
];

interface Props {
  initials: string;
  index: number;
}

export const Avatar: React.FC<Props> = ({ initials, index }) => (
  <span
    aria-hidden
    className={`text-subhead-14 flex size-8 shrink-0 items-center justify-center rounded-full ${avatarColors[index % avatarColors.length]}`}
  >
    {initials}
  </span>
);
